import { generateTestId } from "@client-shared";

export const setShopifyImportModalTestId = (identifier: string): string => generateTestId("ShopifyImportModal", identifier);
